import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react'

interface ModuleInfoContextType {
  moduleInfo: string
  setModuleInfo: React.Dispatch<React.SetStateAction<string>>
}

const ModuleInfoContext = createContext<ModuleInfoContextType>({
  moduleInfo: '',
  setModuleInfo: () => {},
})

export const ModuleInfoProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [moduleInfo, setModuleInfo] = useState<string>('')

  const providerValue = useMemo(
    () => ({ moduleInfo, setModuleInfo }),
    [moduleInfo, setModuleInfo],
  )

  return (
    <ModuleInfoContext.Provider value={providerValue}>
      {children}
    </ModuleInfoContext.Provider>
  )
}

export const useModuleInfo = () => useContext(ModuleInfoContext)
